import React from 'react';

import { Select, TextField, Radio, Checkbox, OutlinedInput, FormControlLabel, RadioGroup , Typography, createStyles, Theme, withStyles, Grid  } from '@material-ui/core';

import { RadioButtonUnchecked , RadioButtonChecked }from '@material-ui/icons';
import { Check, Close, Lens }from '@material-ui/icons';

import styles from '../readyForCarriageCheck.module.css';
import commonStyles from '../../common/common.module.css';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';

const materialStyles = (theme: Theme) =>
  createStyles({
    radioGroup: {
      width: '100%'
    },
    label: {
      color: 'var(--primaryblue)',
      fontSize: '13px',
    },
    mt13px: {
      marginTop:'13px'
    },
    mt16px: {
      marginTop:'16px'
    },
    ukCheck: {
      marginBottom: '-6px'
    },
    mbNeg10: {
      marginBottom: '-10px'
    },
    '@media (max-width: 768px)': {
      mt13px: {
        marginTop: '0'
      },
      mt16px: {
        marginTop: '0'
      },
    }, 
    radioGroupContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      gap: '14px',
      alignItems: 'center',
      width: '100%',
      flexWrap: 'nowrap',
    },
  });

interface SecurityChecksProps {
  classes: any;
  iac: boolean;
  ds: boolean;
  comat: boolean;
  iacNumber: string;
  dsNumber: string;
  flightNumber: string;
  deliveredDate: string;
  shipper: string;
  ccsf: boolean;
  pax: boolean;
  ccsfNumber: string;
  exception: string;
  statusTransportation: boolean;
  statusShipper: boolean;
  handleChange: (event: any) => void;
  handleChangeNumber:( event: any ) => void;
  handleSetSNumber: (event: any) => void;
  checkElement: (check: boolean) => JSX.Element;
  onlyRead?: boolean;
  iacName: string;
  ccsfName: string;
  shipperName: string;
  securityNote: string;
  itsOkay: boolean;
  ccsfType: string;  
};

const TEXT_FIELD_PADDINGS: string = '6px 12px';
const TEXT_FIELD_WIDTH: string = '100%';
const SELECT_FONT_SIZE: string = '13px';
const TEXT_FIELD_HEIGHT: string = '19px';

const flightExceptionType: Array<string> = [
  'AVI (Live Animals)',
  'Live Human Organs',
  'Dept of defence',
  'CBP Order of Exports',
  'Interline transfer',
  'Unknown on Freighter'
]

const securityChecks = (props: SecurityChecksProps) => {

  const flight: string = props.flightNumber.substring(0,2).toUpperCase();
  
  const flightExceptionOptions : Array<JSX.Element> = flightExceptionType.map((exception :string, index: number) => (
    <option key={ index } value={ exception }>{ exception }</option>
  ));

  return (
    <div className={ `${ commonStyles.wrapper } ${ commonStyles.tabBr } ${ styles.height200 }` }>

      <div className={ styles.wrapper }>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} className={`${ styles.scGridItem }`}>
            <div className={`${ commonStyles.fSpaceBtw } ${ props.classes.mt13px }`}>
              <FormControlLabel 
                value="iac" 
                control={
                  <Checkbox
                    color="primary"
                    checked={ props.iac }
                    onChange={ props.handleChange }
                    icon={ <RadioButtonUnchecked fontSize="small" /> }
                    checkedIcon={ <RadioButtonChecked fontSize="small" /> }
                    disabled={ props.onlyRead || props.deliveredDate !== null }
                  />
                }
                label={ <Typography className={ props.classes.label }> Indirect Air Carrier</Typography> }
                className={ styles.formLabel }
              />

              <FormControlLabel 
                value="ds" 
                control={ 
                  <Checkbox
                    color="primary"
                    onChange={ props.handleChange }
                    checked={ props.ds }
                    icon={ <RadioButtonUnchecked fontSize="small" /> } 
                    checkedIcon={ <RadioButtonChecked fontSize="small" /> }
                    disabled={ props.onlyRead || flight === 'PO' || props.deliveredDate !== null }
                    />
                } 
                label={ <Typography className={props.classes.label}> Direct Shipper</Typography> }
                className={ styles.formLabel }
              />

              <FormControlLabel
                value="comat"
                control={
                  <Checkbox
                    color="primary"
                    onChange={props.handleChange}
                    checked={props.comat}
                    icon={<RadioButtonUnchecked fontSize="small" />}
                    checkedIcon={<RadioButtonChecked fontSize="small" />}
                    disabled={ props.onlyRead || props.deliveredDate !== null }
                  />
                }
                label={<Typography className={props.classes.label}> Airline COMAT</Typography>}
                className={styles.formLabel}
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={6} className={`${ styles.scGridItem }`}>
            { props.iac && <div className={ styles.textFieldWrapper }>

              <div  className={  `${styles.elementWidth} ${ commonStyles.inputLabelWrapper } ${ commonStyles.mt0 }`}>
                <label className={ commonStyles.inputLabel }>IAC Number</label>
                <TextField 
                  id="iacNumber"
                  value={ props.iacNumber }
                  variant="outlined"
                  onChange={ props.handleChangeNumber }
                  onBlur={ props.handleSetSNumber}
                  disabled={ (!props.iac || props.onlyRead || props.deliveredDate !== null)}
                  inputProps={{ style: { padding: TEXT_FIELD_PADDINGS, width: TEXT_FIELD_WIDTH, fontSize: SELECT_FONT_SIZE } }}  
                  InputLabelProps={{
                    className: props.classes.labelTransform
                  }}         
                />

              </div>
              <div className={ styles.checkDiv }>
                { props.iac && props.iacNumber  && 
                <div className={ styles.check }>{ props.checkElement( props.statusTransportation )}</div>
                }
              </div>

            </div>}
            { props.ds && <div className={ styles.textFieldWrapper }>
           
                <div  className={  `${styles.elementWidth} ${commonStyles.inputLabelWrapper}`}>

                  <label className={ commonStyles.inputLabel }>Shipper Number</label>
                  <TextField 
                    id="dsNumber"
                    label=""
                    value={ props.dsNumber }
                    variant="outlined"
                    onChange={ props.handleChangeNumber }
                    onBlur={ props.handleSetSNumber}
                    disabled={ flight === 'PO' || ! props.ds || props.onlyRead || props.deliveredDate !== null }
                    inputProps={{ style: { padding: TEXT_FIELD_PADDINGS, width: TEXT_FIELD_WIDTH, fontSize: SELECT_FONT_SIZE } }}                    
                    InputLabelProps={{
                      className: props.classes.labelTransform
                    }}        
                  />
              </div>
                
                { props.ds && props.dsNumber  && 
                  <div className={ styles.check }>{ props.checkElement(props.statusTransportation )}</div>
                }

            </div> }

            <div className={ styles.nameWrapper }>
              { props.iacName && 
                <div>IAC Name: <span className={ styles.textName }>{ props.iacName }</span></div>
              }
              { props.shipperName && 
                <div>Shipper Name: <span className={ styles.textName }>{ props.shipperName }</span></div>
              }
            </div>
          </Grid>
          <Grid item xs={12} sm={6} className={`${ styles.scGridItem }`}>
            <div className= { styles.elementsWrapper }>
              <RadioGroup
                aria-label="shipper"
                name="shipper"
                value={ props.shipper }
                onChange={!props.onlyRead?  props.handleChange: ()=> {}}
                row={ true }
                className={`${ props.classes.radioGroup } ${ commonStyles.fSpaceBtw } ${ props.classes.mt16px }`}
              >

                <FormControlLabel 
                  value="Known" 
                  control={
                    < Radio 
                      color="primary" 
                      icon={ <RadioButtonUnchecked fontSize="small" /> } 
                      checkedIcon={ <RadioButtonChecked fontSize="small" /> }
                    /> 
                  } 
                  label={<Typography className={props.classes.label}> Known Shipper</Typography>}
                  classes={{
                    root: props.classes.radio 
                  }}
                  className={ styles.formLabel }
                  disabled={ flight === 'PO' || props.deliveredDate !== null }
                />

                <FormControlLabel 
                  value="Unknown" 
                  disabled={ props.deliveredDate !== null }
                  control={
                    < Radio 
                      color="primary" 
                      icon={ <RadioButtonUnchecked fontSize="small" /> } 
                      checkedIcon={ <RadioButtonChecked fontSize="small" /> }
                    /> 
                  } 
                  label={<Typography className={props.classes.label}> Unknown Shipper</Typography>}
                  classes={{
                    root: props.classes.radio 
                  }}
                  className={ styles.formLabel }
                />

              </RadioGroup>
            </div>
          </Grid>  
          <Grid item xs={12} sm={6} className={`${ styles.scGridItem } ${ commonStyles.pt0 }`}>
            <div className={ styles.textFieldWrapper }>

              <div  className={`${ styles.elementWidth } ${ commonStyles.inputLabelWrapper } ${ commonStyles.mt0 }`}>
                <div className={`${ commonStyles.fSpaceBtw } ${ props.classes.ukCheck }`}>
                  <label className={`${ commonStyles.inputLabel }  ${ props.classes.ukCheck }`}>Select Exception</label>
                  <FormControlLabel 
                    value="pax" 
                    control={
                      <Checkbox
                        checked={ props.pax }
                        onChange={ props.handleChange }
                        color="primary"
                        disabled={ flight === 'PO' || props.shipper !== 'Unknown' || props.onlyRead || props.deliveredDate !== null }
                        size="small"
                      /> 
                    }
                    label={<Typography className={props.classes.label}> Unknown exceptions</Typography>}
                    className={`${ commonStyles.mr0 }`}
                  />
                </div>

                <Select 
                  native
                  onChange={ props.handleChange }
                  value={ props.exception }
                  id='exception'
                  input={ <OutlinedInput labelWidth={ 0 } /> }
                  disabled={ flight === 'PO'  || props.shipper !== 'Unknown' || props.onlyRead || props.deliveredDate !== null}
                  inputProps={{ style: { padding: TEXT_FIELD_PADDINGS, width: TEXT_FIELD_WIDTH, fontSize: SELECT_FONT_SIZE, height: TEXT_FIELD_HEIGHT } }}           
                >

                  <option value={ '' }> Select Exception </option>
                  { flightExceptionOptions }
                  
                </Select>

              </div>
              
              <div className={ styles.checkDiv }>
                {props.shipper === 'Unknown' && props.pax && props.exception &&
                  <div className={`${styles.check} ${commonStyles.mt2}`}>{props.checkElement(props.statusShipper)}</div>
                }
              </div>

            </div>
          </Grid>
          <Grid item xs={12} sm={6} className={`${styles.scGridItem}`}>
            <div className={styles.elementWidth}>

              <RadioGroup
                row
                aria-label="ccsf-type"
                name="ccsf"
                id='ccsf'
                value={props.ccsfType}
                onChange={props.handleChange}
                className={props.classes.radioGroupContainer}
              >
                <FormControlLabel
                  value="CCSF"
                  control={
                    <Radio
                      color="primary"
                      icon={<RadioButtonUnchecked fontSize="small" />}
                      checkedIcon={<RadioButtonChecked fontSize="small" />}
                      disabled={props.onlyRead || props.deliveredDate !== null || !props.shipper || !props.iac}
                    />
                  }
                  label={<Typography className={props.classes.label}>CCSF</Typography>}
                  className={styles.formLabel}
                />
                <FormControlLabel
                  value="CCSP"
                  control={
                    <Radio
                      color="primary"
                      icon={<RadioButtonUnchecked fontSize="small" />}
                      checkedIcon={<RadioButtonChecked fontSize="small" />}
                      disabled={props.onlyRead || props.deliveredDate !== null || !props.shipper || !props.iac}
                    />
                  }
                  label={<Typography className={props.classes.label}>CCSP</Typography>}
                  className={styles.formLabel}
                />
                <FormControlLabel
                  value="N/A"
                  control={
                    <Radio
                      color="primary"
                      icon={<RadioButtonUnchecked fontSize="small" />}
                      checkedIcon={<RadioButtonChecked fontSize="small" />}
                      disabled={props.onlyRead || props.deliveredDate !== null || !props.shipper || !props.iac}
                    />
                  }
                  label={<Typography className={props.classes.label}>N/A</Typography>}
                  className={styles.formLabel}
                />
              </RadioGroup>

            </div>
          </Grid>
          <Grid item xs={12} sm={6} className={`${styles.scGridItem}`}>
            <div className={`${ styles.textFieldWrapper } ${ commonStyles.mt2 }`}>

              <div  className={  `${styles.elementWidth} ${ commonStyles.inputLabelWrapper } ${ commonStyles.mt0 }`}>

                <label className={ commonStyles.inputLabel }>{props.ccsfType === 'CCSP' ? 'CCSP' : 'CCSF'} Number</label>
                <TextField 
                  id="ccsfNumber"
                  label=''
                  value={ props.ccsfNumber }
                  variant='outlined'
                  onChange={ props.handleChangeNumber }
                  onBlur={ props.handleSetSNumber}
                  disabled={ (props.onlyRead) || props.deliveredDate !== null || (props.ccsfType !== 'CCSF') }
                  inputProps={{ style: { padding: TEXT_FIELD_PADDINGS, width: TEXT_FIELD_WIDTH, fontSize: SELECT_FONT_SIZE } }}                    
                  InputLabelProps={{
                    className: props.classes.labelTransform
                  }}
                />

              </div>
              <div className={ styles.checkDiv }>
                {(props.ccsfNumber) && 
                <div className={ `${styles.check} ${commonStyles.mt2}` }>{ props.checkElement(props.statusShipper )}</div>
                }
              </div>

            </div>
            <div className={ styles.nameWrapper }>
            { props.ccsfName && 
              <div>CCSF Name: <span className={ styles.textName }>{ props.ccsfName }</span></div>
            }
          </div>
          </Grid>
          <Grid item xs={12} className={`${ styles.scGridItem }`}>
            <div  className={  `${styles.elementWidth} ${ commonStyles.inputLabelWrapper } ${ commonStyles.mt0 }  ${styles.securityWidth}`}>

              <label className={ commonStyles.inputLabel }>Security Notes</label>
              <TextField 
                id="securityNote"
                value={ props.securityNote }
                variant="outlined"
                onChange={ props.handleChangeNumber }
                onBlur={ props.handleSetSNumber }
                disabled={ (props.onlyRead || props.deliveredDate !== null)}
                inputProps={{ style: { padding: TEXT_FIELD_PADDINGS, width: TEXT_FIELD_WIDTH, fontSize: SELECT_FONT_SIZE } }}  
                InputLabelProps={{
                  className: props.classes.labelTransform
                }}         
              />
              { ((props.iacNumber.toLowerCase() === 'manual check' || props.dsNumber.toLowerCase() === 'manual check' ) && !props.securityNote )&&
                <div className={ styles.check }>  <Close style={{ color: 'red' }} /></div>
              }
              </div>
          </Grid>
        </Grid>

      </div>

    </div>
  );
}

export default withStyles(materialStyles)(securityChecks);